import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import useFetchProcessos from "../../hooks/processos/useFetchProcessos";
import { IProcesso } from "../../interfaces/processo.interface";
import { mockMovelaria } from "../../interfaces/movelaria.interface";
import useFetchMadeiras from "../../hooks/madeira/useFetchMadeiras";
import { Madeira } from "../../interfaces/madeira.interface";

import styles from './Rastreio.module.scss';

export default function Rastreio() {
    const { uuid } = useParams<{ uuid: string }>();
    const { processos, loading: processosLoading, error: processosError } = useFetchProcessos();
    const { madeiras, madeiraLoading, madeiraError } = useFetchMadeiras();
    const [processo, setProcesso] = useState<IProcesso>();
    const [madeira, setMadeira] = useState<Madeira[]>();

    // Primeiro useEffect para buscar o processo específico com base no uuid
    useEffect(() => {
        const foundProcesso = processos.find(processo => processo.id === uuid);
        setProcesso(foundProcesso);
    }, [processos, uuid]);

    // Segundo useEffect para buscar a madeira correspondente ao processo
    useEffect(() => {
        if (processo) {
            // Se madeiraId for null ou undefined, madeiraIds será um array vazio
            const madeiraIds = processo.madeiraId ? processo.madeiraId.split(',') : [];

            // Filtra as madeiras que possuem IDs correspondentes na lista
            const foundMadeiras = madeiras.filter(madeira => madeiraIds.includes(madeira.id || ""));
            setMadeira(foundMadeiras);
        }
    }, [processo, madeiras]);



    if (processosLoading || madeiraLoading) return <p>Carregando...</p>;
    if (processosError || madeiraError) return <p>Erro ao carregar dados.</p>;

    return (
        <main>
            <section className={styles.container}>
                <h1>Rastreabilidade da Madeira</h1>

                <div className={styles.containerDados}>
                    <div>
                        <h2>Dados do Processo</h2>
                        {processo ? (
                            <div>
                                <p><strong>Produto:</strong> {processo.produto}</p>
                                <p><strong>Quantidade de saida:</strong> {processo.quantidadeDeEntrada}m³</p>
                                <p><strong>Período:</strong> {processo.inicio} a {processo.fim}</p>
                                <p><strong>Status:</strong> {processo.finalizado ? "Finalizado" : "Em andamento"}</p>
                            </div>
                        ) : (
                            <p>Processo não encontrado.</p>
                        )}
                    </div>

                    <div>
                        <h2>Dados da Madeira</h2>
                        {madeira && madeira.length > 0 ? (
                            madeira.map((madeiraItem) => (
                                <div key={madeiraItem.id}>
                                    <p><strong>Nome Popular:</strong> {madeiraItem.nomePopular}</p>
                                    <p><strong>Nome Científico:</strong> {madeiraItem.nomeCientifico}</p>
                                    <p><strong>Placa:</strong> {madeiraItem.placa}</p>
                                    <p><strong>Tora:</strong> {madeiraItem.tora}</p>
                                    <p><strong>Dimensões:</strong> {madeiraItem.expessura} x {madeiraItem.largura} x {madeiraItem.comprimento}</p>
                                    <p><strong>Quantidade:</strong> {madeiraItem.quantidade}</p>
                                    <p><strong>Volume (m³):</strong> {madeiraItem.metroCubico}</p>
                                    <p><strong>Código DOF:</strong> {madeiraItem.DOF}</p>
                                    <a
                                        href={`https://dof.ibama.gov.br/autenticidade`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Verificar autenticidade do DOF
                                    </a>
                                </div>
                            ))
                        ) : (
                            <p>Dados da madeira não encontrados.</p>
                        )}
                    </div>


                    <div>
                        <h2>Dados da Movelaria</h2>
                        {mockMovelaria && (
                            <div>
                                <p><strong>Razão Social:</strong> {mockMovelaria.razaoSocial}</p>
                                <p><strong>CNPJ:</strong> {mockMovelaria.cnpj}</p>
                                <p><strong>Endereço:</strong> {mockMovelaria.endereco}, {mockMovelaria.cidade} - {mockMovelaria.estado}</p>
                                <p><strong>Contato:</strong> Tel: {mockMovelaria.telefone} | Cel: {mockMovelaria.celular}</p>
                                <p><strong>Email:</strong> {mockMovelaria.email}</p>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </main>
    )
}
